import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=9f2d7b0a"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f2d7b0a')) {
      api.createRecord('9f2d7b0a', component.options)
    } else {
      api.reload('9f2d7b0a', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=9f2d7b0a", function () {
      api.rerender('9f2d7b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/Orders.vue"
export default component.exports